import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TransitionGroup } from 'react-transition-group';

import Overlay from '../Widget/Overlay';
import OverlayPublisher from '../Widget/OverlayPublisher';
import OverlayPartner from '../Widget/OverlayPartner';
import WidgetHeader from '../Widget/WidgetHeader';

import { Container, Body } from '../DefaultStyles/Details';
import { Footer } from '../DefaultStyles/Shared';
import {
    ActionContent,
    ActionSuccess,
    Description,
    Header,
    MultiActionsCardActionWrapper,
    PartnerImage,
    Title
} from '../../components/MultiActionsCard/Components';

import CssTransition from '../../components/Transition/CssTransition';
import MultiActionsCardAction from '../../components/MultiActionsCard/MultiActionsCardAction';
import Carousel from '../../components/Shared/Carousel';
import ShareDrawer from '../../components/ShareDrawer';
import LocationChangePopup from '../../components/Volunteer/LocationChangePopup';

import { loadLocalRep } from '../LocalRep/actions';
import { goToFindLocalRep, selectCard } from './actions';
import { copyFor } from '../../copy/copy';

import { onCompleteTweet } from '../Tweet/actions';
import { onCompleteLink } from '../Link/actions';
import {
    fetchVolunteerOpportunities,
    onInitiateVolunteerAction,
    onShowLocationChangePopup
} from '../Volunteer/actions';
import {
    onGoToNextActionInsideCard,
    setOverlayPartnerVisible,
    getApiRequestData
} from '../Widget/actions';

import { getActionCompletedTime } from '../../utils/actionTiming';
import {
    actionCompleted,
    actionSuccess,
    allCompletedActions,
    useLocalRepresentative
} from '../../utils/multiActionsCard/helpers';
import { CardTypes } from '../../utils/enums';
import { isPortrait } from '../../utils/size';
import { Placeholders } from '../../utils/fillDynamicText';
import {
    buildCachedAddress,
    districtInfo,
    relevantRepresentatives,
    joinEnglish
} from '../../utils/localRepresentative/parser';

const actionButton = type => copyFor('multiactionCard', 'button', type);
const actionTitle = type => copyFor('multiactionCard', 'title', type);

const actionDescription = (description, isMobileResolution) => {
    if (!description) return;
    const charLimit = isMobileResolution ? 190 : 135;
    return description.length > charLimit
        ? description.substring(0, charLimit) + '...'
        : description;
};

class MultiActionsCardDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hover: false
        };

        if (!props.localRepFound && props.useLocalRepresentative) {
            props.loadLocalRep(
                props.endUserLocation,
                props.cachedAddress,
                props.representativeSearch
            );
        }
    }

    render() {
        const carouselSettings = {
            arrows: this.props.actions.length > 2,
            enableLabels: false,
            label: '',
            dots: false,
            infinite: false,
            speed: 500,
            swipeToSlide: true,
            centerMode: false,
            slidesToShow: isPortrait() ? 1 : this.props.actions.length > 2 ? 2.21 : 2,
            slidesToScroll: 1,
            focusOnSelect: true,
            draggabe: true
        };

        return (
            <Container>
                <Overlay />
                <OverlayPublisher />
                <OverlayPartner transitionType="right-to-left" />
                <Body>
                    <WidgetHeader />
                    {this.props.isMultiDonation && (
                        <Header
                            onClick={e =>
                                this.props.setOverlayPartnerVisible(true, e, false)
                            }
                            dangerouslySetInnerHTML={{
                                __html: this.props.mutiDonationHeader
                            }}
                        />
                    )}
                    <Carousel
                        carouselSettings={carouselSettings}
                        className={() => (isPortrait() ? 'carousel-mobile' : '')}
                        hover={this.state.hover}
                        isMultiDonation={this.props.isMultiDonation}
                        numActions={this.props.actions.length}
                        onMouseEnter={() => this.setState({ hover: true })}
                        onMouseLeave={() => this.setState({ hover: false })}
                        showSlider={
                            (isPortrait() || this.props.isMultiDonation) &&
                            this.props.actions.length > 1
                        }
                    >
                        {this.props.actions.map(a => (
                            <MultiActionsCardActionWrapper
                                numActions={this.props.actions.length}
                                isMultiDonation={this.props.isMultiDonation}
                                key={a.identifier}
                                selectCard={this.props.selectCard}
                            >
                                {a.type !== 'link' &&
                                    a.type !== 'tweet' &&
                                    actionCompleted(
                                        a,
                                        this.props.completedActionIdentifiers
                                    ) && (
                                        <ActionSuccess>
                                            {actionSuccess(
                                                a.type,
                                                a.identifier,
                                                a.thankYouText,
                                                a.thankYouTitle,
                                                a.recipientMask,
                                                a.useLocalRepresentative,
                                                a.partner ? a.partner.name : '',
                                                a.pollResults,
                                                a.quizResults,
                                                a.name,
                                                a.feedbackText,
                                                a.quizAnsweredCorrect,
                                                a.quizMakeAnswersUppercase,
                                                a.localRepresentativeState,
                                                a.noOfPeopleAnswered
                                            )}
                                        </ActionSuccess>
                                    )}
                                {(a.type === 'link' ||
                                    a.type === 'tweet' ||
                                    !actionCompleted(
                                        a,
                                        this.props.completedActionIdentifiers
                                    )) && (
                                    <ActionContent>
                                        {this.props.isMultiDonation && (
                                            <PartnerImage src={a.partner.logoUrl} />
                                        )}
                                        {!this.props.isMultiDonation && (
                                            <Title>
                                                {a.heading !== null
                                                    ? a.heading
                                                    : actionTitle(a.type)}
                                            </Title>
                                        )}
                                        <Description
                                            dangerouslySetInnerHTML={{
                                                __html: actionDescription(
                                                    this.props.isMultiDonation
                                                        ? a.partner.shortDescription
                                                        : a.name,
                                                    this.props.isMobileResolution
                                                )
                                            }}
                                            onClick={e =>
                                                !this.props.isMultiDonation
                                                    ? this.props.setOverlayPartnerVisible(
                                                          true,
                                                          e,
                                                          false
                                                      )
                                                    : e.preventDefault()
                                            }
                                        />
                                        <MultiActionsCardAction
                                            action={a}
                                            isMultiDonation={this.props.isMultiDonation}
                                            tweetContent={a.textOriginal || ''}
                                            key={a.identifier}
                                            label={
                                                a.label !== null
                                                    ? a.label
                                                    : this.props.isMultiDonation
                                                    ? 'SELECT'
                                                    : actionButton(a.type)
                                            }
                                            partnerName={a.partner ? a.partner.name : ''}
                                            localRepFound={this.props.localRepFound}
                                            localRepPostalCode={
                                                this.props.localRepPostalCode
                                            }
                                            localRepTwitterMention={
                                                this.props.localRepTwitterMention
                                            }
                                            publisherName={this.props.publisherName}
                                            articleUrl={this.props.articleUrl}
                                            showTwitterPopUp={
                                                !a.useLocalRepresentative ||
                                                this.props.localRepFound
                                            }
                                            onClick={
                                                !a.useLocalRepresentative ||
                                                this.props.localRepFound
                                                    ? () => {
                                                          if (isPortrait()) {
                                                              this.props.selectCard(
                                                                  a.position,
                                                                  a.identifier
                                                              );
                                                          }
                                                          if (a.type === 'tweet') {
                                                              this.props.onCompleteTweet(
                                                                  a.apiRequestData,
                                                                  this.props.actionCompletedTime(
                                                                      a.type
                                                                  )(),
                                                                  a.identifier,
                                                                  this.props
                                                                      .endUserLocation
                                                              );
                                                          } else if (a.type === 'link') {
                                                              window.open(
                                                                  a.linkUrl,
                                                                  '_blank'
                                                              );
                                                              this.props.onCompleteLink(
                                                                  a.apiRequestData,
                                                                  this.props.actionCompletedTime(
                                                                      a.type
                                                                  )(),
                                                                  a.identifier,
                                                                  false
                                                              );
                                                          } else if (
                                                              a.type === 'volunteer'
                                                          ) {
                                                              this.props.postalCode
                                                                  ? this.props.onInitiateVolunteerAction(
                                                                        a.identifier
                                                                    ) ||
                                                                    this.props.fetchVolunteerOpportunities(
                                                                        this.props
                                                                            .postalCode,
                                                                        this.props
                                                                            .countryCode,
                                                                        a.id,
                                                                        a.identifier,
                                                                        true,
                                                                        this.props
                                                                            .postalCodeFormPopupIsVisible,
                                                                        false
                                                                    )
                                                                  : this.props.onShowLocationChangePopup(
                                                                        true,
                                                                        a.identifier
                                                                    );
                                                          } else {
                                                              return this.props.onGoToNextActionInsideCard(
                                                                  a.identifier,
                                                                  a.type,
                                                                  true,
                                                                  false
                                                              );
                                                          }
                                                      }
                                                    : () => {
                                                          if (isPortrait()) {
                                                              this.props.selectCard(
                                                                  a.position,
                                                                  a.identifier
                                                              );
                                                          }
                                                          this.props.goToFindLocalRep(
                                                              a.identifier,
                                                              'multiActionsCard'
                                                          );
                                                      }
                                            }
                                        />
                                    </ActionContent>
                                )}
                            </MultiActionsCardActionWrapper>
                        ))}
                    </Carousel>
                    <Footer>
                        <ShareDrawer
                            backgroundColor={'#fff'}
                            newsletterSignUpVisible={true}
                        />
                    </Footer>
                    <TransitionGroup>
                        {this.props.postalCodeFormPopupIsVisible && (
                            <CssTransition
                                key="alert"
                                in={this.props.postalCodeFormPopupIsVisible}
                            >
                                <LocationChangePopup
                                    onBack={() => {
                                        this.props.onShowLocationChangePopup(
                                            false,
                                            this.props.actionIdentifier
                                        );
                                    }}
                                />
                            </CssTransition>
                        )}
                    </TransitionGroup>
                </Body>
            </Container>
        );
    }
}

MultiActionsCardDetails.propTypes = {
    actionCompletedTime: PropTypes.func.isRequired,
    actionIdentifier: PropTypes.string.isRequired,
    actions: PropTypes.array.isRequired,
    articleUrl: PropTypes.string,
    cachedAddress: PropTypes.string,
    completedActionIdentifiers: PropTypes.array,
    countryCode: PropTypes.string,
    endUserLocation: PropTypes.object,
    fetchVolunteerOpportunities: PropTypes.func.isRequired,
    goToFindLocalRep: PropTypes.func.isRequired,
    isMobileResolution: PropTypes.bool.isRequired,
    isMultiDonation: PropTypes.bool,
    loadLocalRep: PropTypes.func.isRequired,
    localRepFound: PropTypes.bool.isRequired,
    localRepPostalCode: PropTypes.string,
    localRepTwitterMention: PropTypes.string,
    mutiDonationHeader: PropTypes.string.isRequired,
    onCompleteLink: PropTypes.func.isRequired,
    onCompleteTweet: PropTypes.func.isRequired,
    onGoToNextActionInsideCard: PropTypes.func.isRequired,
    onInitiateVolunteerAction: PropTypes.func.isRequired,
    onShowLocationChangePopup: PropTypes.func.isRequired,
    postalCode: PropTypes.string,
    postalCodeFormPopupIsVisible: PropTypes.bool.isRequired,
    publisherName: PropTypes.string,
    representativeSearch: PropTypes.object,
    selectCard: PropTypes.func.isRequired,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    useLocalRepresentative: PropTypes.bool
};

export default connect(
    state => {
        const reps = state.localRep.localRepData
            ? relevantRepresentatives(
                  state.widget.activeAction.representativeSearch,
                  state.localRep.localRepData.representative
              ).slice(0, 3)
            : [];

        const repNames = !!state.localRep.localRepData.representative
            ? joinEnglish(reps.map(rep => `${rep.shortName}${districtInfo(rep)}`))
            : null;

        return {
            actionIdentifier: state.widget.activeAction.identifier,
            actionInitiated: state.volunteer.actionInitiated,
            postalCodeFormPopupIsVisible: state.volunteer.postalCodeFormPopupIsVisible,
            isPetition: state.widget.activeAction.type === 'petition',
            isEmail: state.widget.activeAction.type === 'email',
            isTweet: state.widget.activeAction.type === 'tweet',
            isCall: state.widget.activeAction.type === 'call',
            regularRowSize: state.widget.regularRowSize,
            isMobileResolution: state.widget.isMobileResolution,
            postalCode: state.widget.endUserLocation
                ? state.widget.endUserLocation.postalCode
                : undefined,
            countryCode: state.widget.endUserLocation
                ? state.widget.endUserLocation.countryCode
                : 'US',
            endUserLocation: state.widget.endUserLocation,
            localRepFound: state.localRep.localRepData.representative !== undefined,
            localRepPostalCode: state.localRep.localRepData.postalCode,
            localRepTwitterMention: joinEnglish(
                reps.map(rep => {
                    if (rep.twitterMention && rep.twitterMention.length > 0) {
                        return '@' + rep.twitterMention;
                    }
                    return rep.fullName;
                })
            ),
            useLocalRepresentative: useLocalRepresentative(state),
            completedActionIdentifiers: allCompletedActions(state),
            actionCompletedTime: actionType => getActionCompletedTime(state, actionType),
            cachedAddress: buildCachedAddress(
                state.form.google_autocomplete
                    ? state.form.google_autocomplete
                    : state.cachedFormData
            ),
            actions: state.widget.actions
                .filter(function(a) {
                    return a.order === state.widget.activeAction.order;
                })
                .map(a => ({
                    text: a.text || a.description,
                    textOriginal: a.textOriginal || a.description,
                    label: a.customButtonText !== undefined ? a.customButtonText : null,
                    heading: a.customHeader !== undefined ? a.customHeader : null,
                    identifier: a.identifier,
                    id: a.id,
                    type: a.type,
                    position: state.widget.actions.indexOf(a),
                    name: (a.title || a.name)
                        .replace(
                            new RegExp(Placeholders.TwitterMentionPlaceholder, 'g'),
                            joinEnglish(
                                reps.map(rep => {
                                    if (
                                        rep.twitterMention &&
                                        rep.twitterMention.length > 0
                                    ) {
                                        return '@' + rep.twitterMention;
                                    }
                                    return rep.fullName;
                                })
                            )
                        )
                        .replace(
                            new RegExp(Placeholders.PostalCodePlaceholder, 'g'),
                            state.localRep.localRepData.representative != null
                                ? state.localRep.localRepData.postalCode
                                : '@PostalCode'
                        )
                        .replace(
                            new RegExp(Placeholders.ArticleUrl, 'g'),
                            state.widget.articleUrl
                        )
                        .replace(
                            new RegExp(Placeholders.LocalePlaceholder, 'g'),
                            (state.widget.endUserLocation || {}).regionName || 'your area'
                        )
                        .replace(
                            new RegExp(Placeholders.LocalRepresentative, 'g'),
                            repNames || 'Speakable'
                        ),
                    partner: a.partner,
                    useLocalRepresentative: !!a.representativeSearch,
                    localRepresentativeState: a.localRepresentativeState,
                    thankYouText:
                        a.thankYouText || copyFor('multiaction', 'thankYouText'),
                    thankYouTitle: a.thankYouTitle,
                    recipientMask: a.recipientMask,
                    apiRequestData: getApiRequestData(a, state),
                    linkUrl:
                        a.url !== undefined
                            ? a.url.indexOf('http://') === 0 ||
                              a.url.indexOf('https://') === 0
                                ? a.url
                                : 'http://' + a.url
                            : '',
                    resultDistribution: state.sentimentPoll.resultDistribution,
                    pollResults:
                        a.possibleAnswers != null
                            ? a.possibleAnswers
                                  .filter(p => p.isOpen === false)
                                  .map(p => ({
                                      ...p,
                                      percentage:
                                          state.poll.answerHistory !== undefined
                                              ? state.poll.answerHistory.find(
                                                    r =>
                                                        r.actionIdentifier ===
                                                        a.identifier
                                                ) !== undefined
                                                  ? state.poll.answerHistory
                                                        .find(
                                                            r =>
                                                                r.actionIdentifier ===
                                                                a.identifier
                                                        )
                                                        .results.find(
                                                            r => r.answerId === p.id
                                                        ) !== undefined
                                                      ? state.poll.answerHistory
                                                            .find(
                                                                r =>
                                                                    r.actionIdentifier ===
                                                                    a.identifier
                                                            )
                                                            .results.find(
                                                                r => r.answerId === p.id
                                                            ).percentage
                                                      : 0
                                                  : 0
                                              : 0,
                                      highestPercentage:
                                          state.poll.answerHistory !== undefined
                                              ? state.poll.answerHistory.find(
                                                    r =>
                                                        r.actionIdentifier ===
                                                        a.identifier
                                                ) !== undefined
                                                  ? Math.max(
                                                        state.poll.answerHistory
                                                            .find(
                                                                r =>
                                                                    r.actionIdentifier ===
                                                                    a.identifier
                                                            )
                                                            .results.find(
                                                                r => r.isOpen !== false
                                                            ).percentage
                                                    )
                                                  : 0
                                              : 0,
                                      answerAnswered:
                                          state.poll.answerHistoryClicked !== undefined
                                              ? state.poll.answerHistoryClicked.find(
                                                    r =>
                                                        r.actionIdentifier ===
                                                        a.identifier
                                                ) !== undefined
                                                  ? state.poll.answerHistoryClicked
                                                        .filter(
                                                            r =>
                                                                r.actionIdentifier ===
                                                                a.identifier
                                                        )
                                                        .slice(-1)[0].answerId === p.id
                                                  : state.poll.answerHistory !== undefined
                                                  ? state.poll.answerHistory.find(
                                                        r =>
                                                            r.actionIdentifier ===
                                                            a.identifier
                                                    ) !== undefined
                                                      ? state.poll.answerHistory.find(
                                                            r =>
                                                                r.actionIdentifier ===
                                                                a.identifier
                                                        ).answerId === p.id
                                                      : false
                                                  : false
                                              : state.poll.answerHistory !== undefined
                                              ? state.poll.answerHistory.find(
                                                    r =>
                                                        r.actionIdentifier ===
                                                        a.identifier
                                                ) !== undefined
                                                  ? state.poll.answerHistory.find(
                                                        r =>
                                                            r.actionIdentifier ===
                                                            a.identifier
                                                    ).answerId === p.id
                                                  : false
                                              : false,
                                      noOfAnswers: a.possibleAnswers.filter(
                                          p => p.isOpen === false
                                      ).length,
                                      identifier: a.identifier
                                  }))
                            : [],
                    quizResults:
                        a.possibleAnswers != null
                            ? a.possibleAnswers.map(p => ({
                                  ...p,
                                  isCorrect: p.isCorrect,
                                  answerAnswered:
                                      state.quiz.answerHistory !== undefined
                                          ? state.quiz.answerHistory.find(
                                                r => r.actionIdentifier === a.identifier
                                            ) !== undefined
                                              ? state.quiz.answerHistory.find(
                                                    r =>
                                                        r.actionIdentifier ===
                                                        a.identifier
                                                ).answerId === p.id
                                              : false
                                          : false,
                                  noOfAnswers: a.possibleAnswers.length
                              }))
                            : [],
                    quizAnsweredCorrect:
                        state.quiz.answerHistory !== undefined
                            ? state.quiz.answerHistory.find(
                                  r => r.actionIdentifier === a.identifier
                              ) !== undefined
                                ? state.quiz.answerHistory.find(
                                      r => r.actionIdentifier === a.identifier
                                  ).answerId ===
                                  state.quiz.answerHistory
                                      .find(r => r.actionIdentifier === a.identifier)
                                      .results.find(r => r.isCorrect).id
                                : false
                            : false,
                    quizMakeAnswersUppercase:
                        state.quiz.answerHistory !== undefined
                            ? state.quiz.answerHistory.find(
                                  r => r.actionIdentifier === a.identifier
                              ) !== undefined
                                ? state.quiz.answerHistory
                                      .find(r => r.actionIdentifier === a.identifier)
                                      .results.filter(function(a) {
                                          return a.text.length <= 8;
                                      })
                                : []
                            : [],
                    noOfPeopleAnswered: a.noOfAnswers
                        ? (a.noOfAnswers + 1).toLocaleString()
                        : ''
                })),
            mutiDonationHeader:
                state.widget.cards[state.widget.activeAction.order - 1].heading ||
                copyFor('multiaction', 'multiDonationHeader'),
            isMultiDonation:
                state.widget.cards[state.widget.activeAction.order - 1].type ===
                CardTypes.multiDonation,
            publisherName:
                state.widget.twitterMention !== undefined
                    ? '@' + state.widget.twitterMention
                    : state.widget.publisherName,
            articleUrl: state.widget.articleUrl,
            representativeSearch: state.widget.maximumRepresentativeSearch
        };
    },
    {
        onGoToNextActionInsideCard,
        goToFindLocalRep,
        loadLocalRep,
        setOverlayPartnerVisible,
        onCompleteTweet,
        onCompleteLink,
        selectCard,
        getApiRequestData,
        fetchVolunteerOpportunities,
        onInitiateVolunteerAction,
        onShowLocationChangePopup,
    }
)(MultiActionsCardDetails);
